module.exports = __webpack_public_path__ + "static/media/badgeIcon.1e9ee0ae.svg";